import { compose, withHandlers, withState } from 'recompose';
import limitValue from '../../hoc/limitValue';
import CustomAmountInput from '../components/CustomAmountInput';

const CustomAmountInputContainer = compose(
  withState(
    'value',
    'setValue',
    props => (props.defaultValue || 0),
  ),
  withHandlers({
    onChange: props => value => props.setValue(value),
    onSubmit: props => (e) => {
      e.preventDefault();
      props.onSubmit(props.value);
    },
  }),
  limitValue(props => props.max),
);

export default CustomAmountInputContainer(CustomAmountInput);
